import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupBank } from "../../../Shared/NewForms/NFLookupBank";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { useTranslation } from "react-i18next";

const BankAccountDetailMain = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput fieldName={"createdDate"} title={t("Created Date")} />
        </Col>
        <Col sm={6}>
          <NFLookupBank fieldName={"bankId"} title={t("Bank")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput fieldName={"accountNumber"} title={t("Account Number")} />
        </Col>
        <Col sm={6}>
          <NFTextInput fieldName={"foreignBankName"} title={t("Foreign Bank Name")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} required />
        </Col>
        <Col sm={6}>
          <NFLookupCurrency fieldName={"currencyId"} title={t("Currency")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupAccount fieldName={"accountId"} title={t("Account")} />
        </Col>
      </Row>
    </>
  );
};

export default BankAccountDetailMain;
